export type ScoreOrdering =
  | 'score'
  | 'culture_score'
  | 'created_at';

export const ORDER_BY_OPTIONS: { value: ScoreOrdering; label: string }[] = [
  { value: 'score', label: 'Score' },
  { value: 'culture_score', label: 'Culture Score' },
  { value: 'created_at', label: 'Created at' }
];

export const DEFAULT_ORDERING: ScoreOrdering = 'score';
